const EVENT_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  REJECTED: 3,
  DRAFT: 4,
};

const EVENT_TYPES_NAME = {
  1: '活動',
  2: '比賽',
  3: '檢定',
};

const EVENT_TYPES = {
  ACTIVITY: 1,
  TOURNAMENT: 2,
  EXAM: 3,
};
export {EVENT_STATUS, EVENT_TYPES_NAME, EVENT_TYPES};
